import React, { useContext } from 'react';
import { ChoiceCard, Box, Stack, Text } from '@solvhealth/jigsaw-v1';
import styled from 'styled-components';
import UngatedReviewHeader from '../../../../components/AddReview/UngatedReviewHeader';
import useFetchSingleProvider from '../../../../components/ProviderGroup/hooks/useFetchSingleProvider';
import { getProviderName } from '../../../../components/ProviderGroup/Provider/util';
import { ADD_REVIEW_INITIAL } from '../../../../constants';
import { ReviewContext } from '../../context';
import LandingTransition from '../../transitions/LandingTransition';
import { useBreakpoint } from '~/hooks/useBreakpoint';

interface Props {
  reviewOnSolv: () => void;
  reviewOnGoogle: () => void;
}

interface BoxContainerProps {
  $isMobile: boolean | null;
}

const BoxContainer = styled(Box).withConfig({ componentId: 'sc-ivwzp5-0' })`
  text-align: ${(props: BoxContainerProps) => (props.$isMobile ? 'left' : 'center')};
`;

const GoogleOrSolv = ({ reviewOnSolv, reviewOnGoogle }: Props) => {
  const { booking, location, googleUrl, flowState } = useContext(ReviewContext)!;
  const { provider } = useFetchSingleProvider(booking?.providerId);
  const name = provider ? getProviderName(provider) : location?.displayNamePrimary;
  const isMobile = useBreakpoint('tablet', 'below');

  return (
    <LandingTransition
      flowState={flowState}
      stateToActivateFlow={ADD_REVIEW_INITIAL}
      toRender={() => (
        <Stack flexDirection="column" justifyContent="center" mt={10}>
          <UngatedReviewHeader />
          <BoxContainer $isMobile={isMobile} margin={4}>
            <Text variant="h3">Help other patients considering {name}</Text>
          </BoxContainer>
          {googleUrl && (
            <Box margin={2} marginBottom={0}>
              <ChoiceCard
                iconUrl="/images/icons/google-icon.svg"
                onClick={reviewOnGoogle}
                subtitle="Recommended if you have a Gmail account"
                title="Leave a review on Google"
              />
            </Box>
          )}
          <Box margin={2} marginBottom={0}>
            <ChoiceCard
              iconUrl="/images/icons/solv_s_icon.svg"
              onClick={reviewOnSolv}
              title="Leave a review on Solv"
            />
          </Box>
        </Stack>
      )}
    />
  );
};

export default GoogleOrSolv;
